import { axiosInstance } from 'api/instance';
import { uploadEndpoints } from '../upload';

const getUploadURL = (customer, locationId, file_name, file_type, mission) =>
  axiosInstance.get(uploadEndpoints.upload_url(customer, locationId), {
    params: {
      file_name: file_name,
      file_type: file_type,
      mission_id: mission
    }
  });

const saveFileURL = (
  customer,
  locationId,
  mission,
  file_url,
  plant,
  cropPipeline,
  device
) =>
  axiosInstance.post(uploadEndpoints.save_url(customer, locationId, mission), {
    params: {
      file_url: file_url,
      plant: plant,
      crop_pipeline: cropPipeline,
      device: device
    }
  });

const getMissions = (customer, locationId, page, sortAsc) =>
  axiosInstance.get(uploadEndpoints.get_missions(customer, locationId), {
    params: {
      page: page,
      sort_asc: sortAsc
    }
  });

const getMissionFiles = (customer, locationId, missionId) =>
  axiosInstance.get(uploadEndpoints.get_mission_files(customer, locationId, missionId));

const deleteFile = (customer, locationId, mission, file_name) =>
  axiosInstance.post(uploadEndpoints.delete_file(customer, locationId, mission), {
    params: {
      file_name: file_name
    }
  });

const deleteMission = (customer, locationId, mission) =>
  axiosInstance.post(uploadEndpoints.delete_mission(customer, locationId, mission));

const runMission = (customer, locationId, mission) =>
  axiosInstance.post(uploadEndpoints.run_mission(customer, locationId, mission));

const getPlants = () => axiosInstance.get(uploadEndpoints.get_plants());
const getSubscriptionCrops = () =>
  axiosInstance.get(uploadEndpoints.get_subscription_crops());
export const uploadRequests = {
  getUploadURL,
  saveFileURL,
  getMissions,
  getMissionFiles,
  deleteFile,
  deleteMission,
  runMission,
  getPlants,
  getSubscriptionCrops
};
